import type { CreateClientFormData, EditClientData } from '@/types/clientsApiTypes';

type EmergencyContactFields = Pick<
  CreateClientFormData['primary_passenger']['client'],
  | 'client_id'
  | 'emergency_contact_name'
  | 'emergency_relationship_type_id'
  | 'emergency_contact_phone'
  | 'emergency_contact_email'
>;

export const getEmergencyContactPayload = (
  values: EmergencyContactFields
): Partial<EditClientData['client']> => {
  return {
    id: values.client_id,
    emergency_contact_name: values.emergency_contact_name,
    emergency_relationship_type_id: values.emergency_relationship_type_id,
    emergency_contact_phone: values.emergency_contact_phone,
    emergency_contact_email: values.emergency_contact_email ?? undefined,
  };
};
